import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
const SalesRegisterComponent = loadable(
  () => import("../../components/CBMSReports/SalesRegister")
);

const SalesRegister = () => {
  return (
    <>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>Sales Register</h1>
      </div>
      <SalesRegisterComponent />
    </>
  );
};

export default SalesRegister;
